module.exports = __webpack_public_path__ + "static/media/Estampa_Card5.bbba9dc3.png";